import React from 'react';
import styled, { css } from 'styled-components';
import Text from '../../Atoms/Text/Text';
import Picture from '../../Atoms/Picture/Picture';
import link from '../../Atoms/Link/Link';
import spacing from '../../../theme/shared/spacing';
import SR from '../../Atoms/Logo/assets/sr-logo.svg';
import CR from '../../Atoms/Logo/assets/cr-logo.svg';
import RND from './assets/RND.png';
/**
 * Article Teaser
 */

var Wrapper = styled.article.withConfig({
  displayName: "ArticleTeaser__Wrapper",
  componentId: "sc-1r8ed89-0"
})(["width:100%;height:100%;display:flex;background-color:#fff;"]);
var Link = styled(link).withConfig({
  displayName: "ArticleTeaser__Link",
  componentId: "sc-1r8ed89-1"
})(["padding:0;display:flex;height:100%;flex-direction:", ";align-items:", ";text-decoration:none;color:inherit;width:100%;@media ", "{flex-direction:row;}@media ", "{flex-direction:", ";}"], function (_ref) {
  var category = _ref.category;
  return category || category === '' ? 'row' : 'column';
}, function (_ref2) {
  var category = _ref2.category;
  return (category || category === '') && 'center';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoint('small');
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoint('medium');
}, function (_ref5) {
  var category = _ref5.category;
  return !category && category !== '' && 'column';
});
var ImageWrapper = styled.div.withConfig({
  displayName: "ArticleTeaser__ImageWrapper",
  componentId: "sc-1r8ed89-2"
})(["padding-left:", ";display:flex;align-items:center;justify-content:center;position:relative;", ";"], function (_ref6) {
  var category = _ref6.category;
  return (category || category === '') && "".concat(spacing('md'));
}, function (_ref7) {
  var category = _ref7.category;
  return !category && category !== '' && css(["@media ", "{width:45%;}@media ", "{width:100%;}"], function (_ref8) {
    var theme = _ref8.theme;
    return theme.breakpoint('small');
  }, function (_ref9) {
    var theme = _ref9.theme;
    return theme.breakpoint('medium');
  });
});
var CopyWrapper = styled.div.withConfig({
  displayName: "ArticleTeaser__CopyWrapper",
  componentId: "sc-1r8ed89-3"
})(["padding:", ";", ";@media ", "{width:100%;}"], spacing('l'), function (_ref10) {
  var category = _ref10.category;
  return !category && category !== '' && css(["@media ", "{width:55%;}"], function (_ref11) {
    var theme = _ref11.theme;
    return theme.breakpoint('small');
  });
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.breakpoint('medium');
});
var Title = styled(Text).withConfig({
  displayName: "ArticleTeaser__Title",
  componentId: "sc-1r8ed89-4"
})(["margin:0;"]);
var Image = styled(Picture).withConfig({
  displayName: "ArticleTeaser__Image",
  componentId: "sc-1r8ed89-5"
})(["display:flex;"]);

var handleCampaignLogo = function handleCampaignLogo(category) {
  switch (category) {
    case 'Comic Relief':
      return CR;

    case 'Sport Relief':
      return SR;

    case 'Red Nose Day':
      return RND;

    default:
      return CR;
  }
};
/**
 * Article teaser component
 */


var ArticleTeaser = function ArticleTeaser(_ref13) {
  var href = _ref13.href,
      date = _ref13.date,
      title = _ref13.title,
      imageLow = _ref13.imageLow,
      image = _ref13.image,
      images = _ref13.images,
      alt = _ref13.alt,
      category = _ref13.category,
      logoSize = _ref13.logoSize,
      family = _ref13.family;
  return React.createElement(Wrapper, null, React.createElement(Link, {
    href: href,
    type: "standard",
    category: category,
    underline: false
  }, React.createElement(ImageWrapper, {
    category: category
  }, React.createElement(Image, {
    imageLow: !category && category !== '' ? imageLow : handleCampaignLogo(category),
    images: !category && category !== '' ? images : handleCampaignLogo(category),
    image: image,
    alt: alt,
    objectFit: "cover",
    width: category || category === '' ? logoSize : '100%',
    height: category || category === '' ? logoSize : '100%'
  })), React.createElement(CopyWrapper, {
    category: category
  }, React.createElement(Text, {
    size: "xxs",
    weight: "800",
    uppercase: true
  }, date), React.createElement(Title, {
    size: "xl",
    tag: "h3",
    height: "2rem",
    weight: "normal",
    uppercase: true,
    family: family
  }, title))));
};

ArticleTeaser.defaultProps = {
  imageLow: null,
  image: null,
  images: null,
  category: null,
  logoSize: null,
  family: 'Anton'
};
export default ArticleTeaser;